<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>

        <v-col class="pa-2" cols="12" md="4">
          <div class="sticky-md" style="top: 110px">
            <qr-maker />
            <v-card-actions class="justify-center d-none" >
              <div
                class="rowinfo"
                style="
                  justify-content: center !important;
                  align-items: center !important;
                "
              >
                <v-btn class="btn-download" @click="showDialog = true">
                  <v-icon>mdi-progress-download</v-icon>
                  {{ $t("download_qr") }}                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-download`"
                  :help-data="helpData"
                  :service-name="serviceName"
                  class="buttoninfo"
                  label="دانلود کیوآر"
                  style="
                    padding: unset !important;
                    align-self: center !important;
                  "
                />
              </div>
            </v-card-actions>
          </div>
        </v-col>

        <v-col class="pa-3" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-content-start">
                <div class="col-md-12">
                  <p>ورود اطلاعات</p>
                </div>
                <div v-if="qrType" class="col-md-12 mt-0 pt-0">
                  <v-row>
                    <v-col cols="12" v-if="(cache===false && type_link==='order') || cache===true">                        
                          <v-alert  type="warning" border="left" color="warning" colored-border elevation="6" small>
                            <span v-if="cache">فعال شدن کش، سرعت انتقال کاربر به صفحه سرچ گوگل را کاهش میدهد.</span>
                            <span v-if="cache===false && type_link==='order'">در صورتی که کش غیرفعال باشد و حالت نمایش روی «ترتیبی» تنظیم شود، کاربران کلمات کلیدی تکراری مشاهده خواهند کرد.</span>
                          </v-alert>
                  </v-col>
                    <!-- فیلد نام کیوآر -->
                    <v-col cols="12" md="5" class="d-flex align-center">

                      <div class="rowinfo w-100 algin-items-start">
                        <v-text-field
                          v-model="visitName"
                          :disabled="e6 > 1"
                          append-icon="mdi-pen"
                          class="mt-0 pt-0 contentinfo w-100"
                          clear-icon="mdi-close-circle-outline"
                          clearable
                          dense
                          label="نام کیوآر"
                          outlined
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-visitName`"
                          :help-data="helpData"
                          :service-name="serviceName"
                          class="buttoninfo"
                          label="نام کیوآر"
                        />
                      </div>
                    </v-col>
                    <!-- فیلد نوع توزیع کلیدواژه -->
                    <v-col cols="12" md="4" class="d-flex align-center">
                      <div class="rowinfo w-100 algin-items-start">
                        <v-select
                          v-model="type_link"
                          :items="typeLinkOptions"
                          dense
                          outlined
                          label="نحوه توزیع کلیدواژه‌ها"
                          class="w-100 mt-0 pt-0 contentinfo"
                        >
                          <template v-slot:append-outer>
                            <!-- اضافه شدن رنگ سفید و سایه ملایم به تولتیپ -->
                            <v-tooltip bottom max-width="320" color="white" content-class="elevation-10">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon color="info" small v-bind="attrs" v-on="on" style="margin-top: -4px;">
                                  mdi-help-circle-outline
                                </v-icon>
                              </template>
                              <!-- متن خاکستری تیره برای کل توضیحات -->
                              <div class="text-right grey--text text--darken-3" style="line-height: 1.8; font-size: 13px;">
                                <strong class="black--text">نحوه جستجوی کلیدواژه در گوگل:</strong><br />
                                <!-- عناوین مشکی -->
                                <span class="black--text font-weight-bold">۱. ترتیبی:</span> جستجو دقیقاً به همان ترتیبی که کلمات را وارد کرده‌اید انجام می‌شود.<br />
                                <span class="black--text font-weight-bold">۲. تصادفی:</span> از بین کلمات لیست، کلمات به صورت کاملاً رندوم برای جستجو انتخاب می‌شود.<br />
                                <span class="black--text font-weight-bold">۳. تصادفی درصدی:</span> کلمه کلیدی بر اساس درصدِ شانسی که برای آن تعیین کرده‌اید انتخاب و سرچ می‌شود.
                              </div>
                            </v-tooltip>
                          </template>
                        </v-select>

                        <help-info
                          :element-name="`${serviceName}-${componentName}-type_link`"
                          :help-data="helpData"
                          :service-name="serviceName"
                          class="buttoninfo"
                          label="نحوه توزیع"
                        />
                      </div>
                    </v-col>

                    <v-col cols="12" md="3" class="d-flex align-center">
                      <v-switch
                        v-model="cache"
                        dense
                        outlined
                        label="کش کردن IP جستجوگران"
                        class="w-100 mt-0 pt-0"
                        style="font-size: x-small;"
                      />
                    </v-col>

                  </v-row>
                </div>
              </div>
            </v-stepper-step>

            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <list-expansion icon="bullseye-arrow" mandatory single title="کلیدواژه‌ها">
                <template v-slot:content>
                  
                  <div class="links-container pa-2">
                    
                    <!-- نمایش وضعیت درصدها -->
                      <v-alert
                        v-if="isPercentType"
                        dense
                        :type="totalPercent === 100 ? 'success' : totalPercent > 100 ? 'error' : 'warning'"
                        class="mb-4"
                        outlined
                      >
                        مجموع درصدها: <strong>{{ totalPercent }}٪</strong>
                        <span v-if="totalPercent > 100">
                          (خطا: مجموع درصدها <strong dir="ltr" style="display: inline-block;">{{ Math.abs(remainingPercent) }}٪</strong> بیشتر از ۱۰۰ است. لطفاً مقادیر را اصلاح کنید)
                        </span>
                        <span v-else-if="totalPercent < 100">
                          (مقدار <strong dir="ltr" style="display: inline-block;">{{ remainingPercent }}٪</strong> باقی‌مانده است)
                        </span>
                        <span v-else> (مجموع به درستی تنظیم شده است) </span>
                      </v-alert>
                    <v-card 
                        v-for="(item, index) in linkItems" 
                        :key="item.id"
                        class="mb-4 pa-3 elevation-1 rounded-lg"
                        outlined
                      >
                        <v-row>
                          <v-col cols="12" sm="12" md="12" class="pb-0">
                            <v-text-field
                              v-model="item.link"
                              :rules="[keyRules.checkKey]"
                              :append-icon="$vuetify.breakpoint.xsOnly ? '' : 'mdi-bullseye-arrow'"
                              clearable
                              dense
                              hide-details="auto"
                              hint="مثلاً: کمپین بهاره"
                              label="کلمه کلیدی"
                              outlined
                              placeholder="کلمه کلیدی موردنظر خود را وارد کنید"
                            />
                          </v-col>
                          
                              <v-col v-if="isPercentType" cols="12" sm="6" md="6" class="pb-0">
                                <v-text-field
                                  v-model="item.percent"
                                  type="number"
                                  dense
                                  max="100"
                                  min="1"
                                  :rules="percentRules"
                                  hide-details="auto"
                                  label="درصد نمایش"
                                  outlined
                                  placeholder="1 تا 100"
                                />
                              </v-col>                       
                             </v-row>

                        <v-row no-gutters align="center" class="mt-2">
                          <v-col class="pa-1 mt-2 mt-sm-0 d-flex justify-end align-center" cols="12">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon color="primary" :disabled="index === 0" v-bind="attrs" v-on="on" @click="moveUp(index)">
                                  <v-icon small>mdi-arrow-up</v-icon>
                                </v-btn>
                              </template>
                              <span>انتقال به بالا</span>
                            </v-tooltip>

                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon color="primary" :disabled="index === linkItems.length - 1" v-bind="attrs" v-on="on" @click="moveDown(index)">
                                  <v-icon small>mdi-arrow-down</v-icon>
                                </v-btn>
                              </template>
                              <span>انتقال به پایین</span>
                            </v-tooltip>

                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon color="error" v-bind="attrs" v-on="on" @click="removeLink(index)">
                                  <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>حذف کلیدواژه</span>
                            </v-tooltip>
                          </v-col>
                      </v-row>
                  </v-card>

                    <v-btn
                      block
                      class="mt-2 btn-get-code rounded-lg"
                      :disabled="isPercentType && totalPercent >= 100"
                      @click="addLink"
                      @mousedown.prevent
                    >
                      <v-icon left>mdi-plus</v-icon>
                      افزودن کلید واژه جدید
                    </v-btn>
                  </div>
                  
                </template>
              </list-expansion>

              <div class="col-md-12 mt-4">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="submitData"
                >
                  {{ info.qrId ? 'ویرایش کیوآر کلیک یار سئو' : 'ساخت کیوآر کلیک یار سئو' }}
                </next-btn>
              </div>
            </v-stepper-content>

            <div style="visibility: hidden">
              <qr-code-make
                ref="qrCanvas"
                v-model="qrDesign"
                :file.sync="qrSvgDataUrl"
                :link="previewLink"
                @save="qrDesign = $event"
              />
            </div>
          </v-stepper>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: 'دانلود کیوآر' }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-download-Qr-d`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>

          <v-card class="pa-5">
              <download-file-with-api
              v-if="showDialog"
              :address="`${data?.domain?.name||'qrland.in/'}${data.identifier}`"
              :visit-name="visitName"
              @close="showDialog = false"
              :qr_id="data?.qrId?.replace('?gateway=true','')"
              :is-qrlink="true"
            />
          </v-card>
        </custom-popup>
      </v-row>
      
      <QrIntroModal v-if="$vuetify.breakpoint.mdAndUp"
        storageKey="clickyarseoIntroSeen"
        title="کیوآر کلیک یار سئو"
        :pro="false"
        icon="mdi-bullseye-arrow"
        iconColor="amber darken-2"
        :description="introText"
      />
    </template>
  </help-info-wrapper>
</template>

<script>
import { getLanguageCookie } from "../../../core/plugins/TitleRibbon/utils/languageCookie.js";
import QrCodeMake from "../qrland/qrCodeStyle/qrCodeMake.vue";
import QrMaker from "../qrland/components/qrMaker.vue";
import QrManagement from "../qrland/components/qrManage/qrManagement.vue";
import ListExpansion from "../../content/fragments/listExpansion.vue";
import NextBtn from "../../content/fragments/nextBtn.vue";
import PrevBtn from "../../content/fragments/prevBtn.vue";
import QrAddressField from "../../content/fragments/qrAddressField.vue";
import { debounce } from "../../../main.js";
import { mapActions } from "vuex";
import DownloadFileWithApi from "../qrland/downloadFileWithApi.vue";
import QrIntroModal from "../../pages/QrIntroModal.vue";

export default {
  name: "clickyarseo",

  components: {
    QrAddressField,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrManagement,
    QrMaker,
    QrCodeMake,
    DownloadFileWithApi,
    QrIntroModal
  },

  data() {

    return {
      link:"",
      cache:false,
      keyRules: {checkKey:(value)=>!!value ||'کلمه کلیدی باید انتخاب شود'},
    
    percentRules: [
      v => !!v || 'وارد کردن درصد الزامی است',
      v => (v > 0 && v <= 100) || 'درصد نمی‌تواند بیشتر از 100 باشد'
    ],

    linkItems: [
      { id: this.generateTempId(), key: null, link: "", title: "", percent: null }
    ],
      introText: `
        <strong>کیوآر کلیک یار سئو</strong> ابزاری هوشمند برای مدیریت و توزیع ترافیک روی کلیدواژه‌های مختلف است. شما می‌توانید چندین کلیدواژه را به لیست اضافه کنید تا کاربران از طریق جستجو در گوگل به سایت شما هدایت شوند.
        <br><br>
        <strong>چگونه کار می‌کند؟</strong> با هر بار اسکن شدن کیوآر کد، سیستم به صورت خودکار کاربران را به یکی از کلیدواژه‌های لیست شما هدایت می‌کند. شما می‌توانید نحوه توزیع این ترافیک را به یکی از سه روش زیر تنظیم کنید:
        <br><br>
        <span style="padding-right: 15px; display: block;">
          <strong>۱. ترتیبی:</strong> جستجو در گوگل دقیقاً به همان ترتیبی که کلمات را وارد کرده‌اید، به نوبت انجام می‌شود.<br>
          <strong>۲. تصادفی:</strong> در هر اسکن، یک کلیدواژه از بین لیست شما به صورت کاملاً تصادفی (رندوم) برای جستجو انتخاب می‌شود.<br>
          <strong>۳. تصادفی درصدی:</strong> هر کلیدواژه دقیقاً بر اساس درصدی (شانسی) که برای آن مشخص کرده‌اید انتخاب و سرچ می‌شود.
        </span>
        <br>
        این ویژگی برای <strong>کمپین‌های سئو</strong>، شبیه‌سازی رفتار طبیعی کاربر و توزیع دقیق ترافیک ارگانیک بسیار کاربردی است.
      `,

      helpData: [],
      serviceName: "Qrland",
      componentName: "clickyarseo",
      info: {},
      qrSvgDataUrl: "",
      qrType: true,
      showDialog: false,
      loading: false,
      dtUrl: null,
      e6: 1,
      visitName: "کلیک یار سئو",
      
      type_link: "order",
      typeLinkOptions: [
        { text: 'ترتیبی', value: 'order' },
        { text: 'تصادفی', value: 'random' },
        { text: 'تصادفی درصدی', value: 'random_percent' }
      ],

      
      linkItems: [
        { id: this.generateTempId(), key: null, link: "", title: "", percent: null }
      ],
      initiallinkItems: [],
      removedKeys: [],

      data: {
        identifier: "",
        qrId: null,
        domain: { name: "" }
      },
      qrDesign: null,
    };
  },

  computed: {
    previewLink() {

    
      return this.link? this.link: "https://qrland.in";
    },
    isPercentType() {
      return this.type_link === 'random_percent';
    },
    totalPercent() {
      return this.linkItems.reduce((sum, item) => sum + (Number(item.percent) || 0), 0);
    },
    remainingPercent() {
      return 100 - this.totalPercent;
    }
  },

  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.updateQr();
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
    "data.link"(val) {
      debounce(() => {
        this.updateQr();
      }, 500);
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
 
    generateTempId() {
      return 'temp_' + Math.random().toString(36).substr(2, 9);
    },

    addLink() {
      if (this.linkItems.length >= 50) {
        this.$toast.error("حداکثر ۵۰ کلید واژه می‌توانید اضافه کنید.");
        return;
      }

      // چک کردن مجموع درصد برای جلوگیری از اضافه شدن کلیدواژه جدید
      if (this.isPercentType && this.totalPercent >= 100) {
        this.$toast.error("مجموع درصدها به ۱۰۰ رسیده است یا از آن عبور کرده. لطفاً درصدها را اصلاح کنید.");
        return;
      }

      const hasEmpty = this.linkItems.some(item => !item.link || item.link.trim() === "");
      if (hasEmpty) {
        this.$toast.info("لطفاً ابتدا کلیدواژه‌های خالی را پر کنید.");
        return;
      }
      const links = this.linkItems.map(item => item.link.trim());
      if (new Set(links).size !== links.length) {
        this.$toast.error("کلیدواژه تکراری وجود دارد. لطفاً آن‌ها را حذف یا اصلاح کنید.");
        return;
      }
            
      this.linkItems = [
        ...this.linkItems,
        {
          id: this.generateTempId(),
          key: null,
          link: "",
          title: "",
          percent: null
        }
      ];
    },

    removeLink(index) {
      const item = this.linkItems[index];
      if (item.key) {
        this.removedKeys.push(item.key);
      }
      
      const newItems = [...this.linkItems];
      newItems.splice(index, 1);
      this.linkItems = newItems;
      
      if (this.linkItems.length === 0) {
        this.addLink();
      }
    },

    moveUp(index) {
      if (index > 0) {
        const newItems = [...this.linkItems];
        const item = newItems.splice(index, 1)[0];
        newItems.splice(index - 1, 0, item);
        this.linkItems = newItems;
      }
    },

    moveDown(index) {
      if (index < this.linkItems.length - 1) {
        const newItems = [...this.linkItems];
        const item = newItems.splice(index, 1)[0];
        newItems.splice(index + 1, 0, item);
        this.linkItems = newItems;
      }
    },

    validateAllLinks() {
      const links = [];
      for (let item of this.linkItems) {
        if (!item.link ) {
          this.$toast.error(" تمامی کلیدواژه‌ها باید معتبر و با  باشد.");
          return false;
        }
        links.push(item.link.trim());
      }
      if(new Set(links).size !== links.length){
        this.$toast.error("کلیدواژه تکراری مجاز نیست. لطفاً بررسی کنید.");
        return false;
      }
      
      // بررسی دقیق 100 درصد در صورت انتخاب توزیع درصدی
      if (this.isPercentType && this.totalPercent !== 100) {
        this.$toast.error(`مجموع درصدها باید دقیقاً $100$ باشد. مقدار فعلی: ${this.totalPercent}`);
        return false;
      }
      
      return true;
    },

    submitData() {
      if (!this.validateAllLinks()) return;

      if (this.info && this.info.qrId) {
        this.qrUpdate();
      } else {
        this.markQr();
      }
    },

      markQr() {
      const trimmedId = this.data.link
        ? this.data.link.trim().replace(/https?:\/\/+/i, "")
        : "";

      this.loading = true;
      
      const linksPayload = this.linkItems.map(item => ({
        link: item.link,
        percent: item.percent || null
      }));

      let obj = {
        type: "clickyarseo",
        qrType: "dynamic",
        identifier: trimmedId,
        title: this.visitName,
        link_type: this.type_link, // اصلاح شد (به جای type_link)
        cache: this.cache,         // ارسال فیلد کش اضافه شد
        links: linksPayload,
        qr: JSON.stringify(this.qrDesign),
      };

      this.$api
        .post("/v1/testQr/store1", obj)
        .then(({ data }) => {
          this.info = data.data;
          this.data.qrId = data.data.id;
          this.link = data.data.link;
          
          if (data.data.links && typeof data.data.links === 'object') {
             this.initiallinkItems = Object.keys(data.data.links).map(key => {
               const lData = data.data.links[key];
               return {
                  id: key,
                  key: key,
                  link: lData.link || lData, 
                  percent: lData.percent || null
               };
             });
             this.linkItems = [...this.initiallinkItems];
          }

          this.$toast.success("کیوآر کلیک یار سئو شما با موفقیت ساخته شد.");
          this.setCreatedQrID(data.data.id);
          this.setQrType("clickyarseo");

          if (this.e6 === 1) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(this.previewLink);
              }, 500);
              setTimeout(() => {
                this.qrUpdate();
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);

          this.handleError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

       qrUpdate() {
      const trimmedId = this.data.link
        ? this.data.link.replace(/https?:\/\/+/i, "")
        : "";

      this.loading = true;
      const formData = new FormData();
      formData.append("type", "clickyarseo");
      formData.append("image", this.qrSvgDataUrl);
      formData.append("qrType", "dynamic");
      formData.append("identifier", trimmedId);
      formData.append("title", this.visitName);
      formData.append("_method", "PUT");
      formData.append("link_type", this.type_link); // اصلاح شد (به جای type_link)
      formData.append("qr", JSON.stringify(this.qrDesign));
      formData.append("qr_id", this.info.qrId || this.data.qrId); 
      formData.append("cache", this.cache ? 1 : 0); // اصلاح اشتباه تایپی catch به cache و ارسال ۱ یا ۰
      
      this.linkItems.forEach((item, index) => {
        formData.append(`links[${index}][link]`, item.link);
        formData.append(`links[${index}][percent]`, item.percent || "");
        
        // ارسال key فقط برای لینک‌هایی که از قبل وجود داشته‌اند (جلوگیری از ارسال مقادیر temp_)
        if (item.key && !String(item.id).startsWith('temp_')) {
          formData.append(`links[${index}][key]`, item.key);
        }
      });

      this.removedKeys?.forEach(key => formData.append("removedKeys[]", key));

      this.$api
        .post("/v1/testQr/update", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          this.$toast.success("کیوآر کلیدواژه شما باموفقیت ویرایش شد.");
          
          if (res.data && res.data.data && res.data.data.links) {
            this.removedKeys = [];
            this.initiallinkItems = Object.keys(res.data.data.links).map(key => {
               const lData = res.data.data.links[key];
               return {
                  id: key,
                  key: key,
                  link: lData.link || lData, 
                  percent: lData.percent || null
               };
             });
             this.linkItems = [...this.initiallinkItems];
          }

          if (this.e6 === 1) {
            setTimeout(() => {
              this.$router.push(`/qr/list`);
            }, 500);
          }
        })
        .catch((err) => {
           console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },


    handleError(error) {
      const response = error.response;
      const errorMap = {
        "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
      };

      if (response?.data?.errors) {
        const backendErrors = response.data.errors;
        Object.entries(backendErrors).forEach(([fieldKey, fieldMessages]) => {
          const msg = fieldMessages[0];
          const key = errorMap[msg];
          this.$toast.error(key ? this.$t(key) : msg, { timeout: 3000 });
        });
      } else {
        this.$toast.error(this.$t("qr_creation_failed"));
      }
    },

    updateQr() {
      setTimeout(() => {
        if (this.$refs.qrCanvas && this.previewLink) {
          this.$refs.qrCanvas.appendCanvas(this.previewLink);
        }
      }, 500);
    },

    isURL(str) {
      if (!str) return false;
      try {
        const url = new URL(str);
        const res1 = url.protocol === "http:" || url.protocol === "https:";
        const regex = /^(https?:\/\/)([a-zA-Z0-9.-]+(\.[a-zA-Z]{2,})+)[^\s]*$/;
        const res2 = regex.test(str.trim());
        return res2 && res1;
      } catch (err) {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.border-dashed {
  border-style: dashed !important;
  border-width: 2px !important;
}
</style>
